module.exports = __webpack_public_path__ + "img/saldo_terakhir.71fd0e64.svg";